import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ProjectPropOne from "../component/project/itemProp/ProjectPropOne";
import Tilty from "react-tilty";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientSlider from "../component/client/ClientSlider";
import { FaAngleRight } from "react-icons/fa";

const Sustainability = () => {
  // Static data for detailsService
  const detailsService = {
    title: "Sustainability",
    description:
      "At UCWF, energy efficiency is a key pillar of our sustainability-driven facilities management approach. We focus on implementing advanced technologies and strategic solutions to reduce energy consumption, lower operational costs, and minimize environmental impact. <br /> <br />  Energy efficiency is not only an eco-friendly choice but also a cost-effective strategy that enhances performance and extends asset lifespan. Partner with UCWF for sustainable, energy-efficient solutions that reduce costs and optimize your facilities.  ",
    image: "/images/sustainabilityucwf/sustainabilityinnerbanner.webp",
    process: {
      steps: [
        {
          id: 1,
          icon: "/images/icon/productivity_8260896.png",
          title: "Smart Automation & Energy Management Systems ",
          paragraph:
            "We integrate intelligent building automation systems (BAS) that monitor and control energy usage in real time. These systems optimize lighting, HVAC, and other essential building operations, ensuring maximum efficiency while maintaining comfort and safety. ",
        },
        {
          id: 2,
          icon: "/images/icon/bulb_2317515.png",
          title: "LED Lighting Solutions ",
          paragraph:
            "Switching to LED lighting significantly reduces energy consumption while providing better illumination and longer lifespan compared to traditional lighting. We design and install energy-efficient lighting systems tailored to each facility's needs, incorporating motion sensors and daylight harvesting for further efficiency gains. ",
        },
        {
          id: 3,
          icon: "/images/icon/solar-energy_1997279.png",
          title: "Renewable Energy Solutions",
          paragraph:
            "We support the transition to clean energy by implementing solar power systems, energy-efficient HVAC solutions, and other renewable energy technologies. These initiatives help facilities reduce their reliance on non-renewable sources and contribute to a greener, more sustainable environment. ",
        },
        {
          id: 4,
          icon: "/images/icon/hvacicon.png",
          title: "HVAC Optimization & Energy Audits ",
          paragraph:
            "Heating, ventilation, and air conditioning (HVAC) systems are among the largest energy consumers in any facility. We conduct comprehensive energy audits to identify inefficiencies and implement solutions like variable frequency drives (VFDs), advanced thermostats, and energy recovery systems to optimize HVAC performance. ",
        },
        {
          id: 5,
          icon: "/images/icon/greencleaning.png",
          title: "Green Cleaning & Eco-Friendly Products",
          paragraph:
            "Our cleaning services prioritize biodegradable cleaning agents and non-toxic materials, ensuring indoor spaces remain hygienic while reducing environmental harm. ",
        },
        {
          id: 6,
          icon: "/images/icon/eco-bulb_10065221.png",
          title: "Sustainable Impact & Cost Savings",
          paragraph:
            "Our energy-efficient solutions not only help businesses lower their carbon footprint but also significantly reduce utility bills and maintenance costs. By integrating sustainability-focused energy practices, UCWF ensures that facilities operate efficiently while aligning with global environmental goals.",
        },
        {
          id: 7,
          icon: "/images/icon/pollution_6122987.png",
          title: "Carbon Footprint Reduction ",
          paragraph:
            "We adopt low-emission operations, electric fleet vehicles, and sustainable procurement practices to significantly cut down carbon emissions and promote greener business operations. ",
        },
      ],
      thumb1: "/images/sustainability-thumb1.jpg",
      thumb2: "/images/sustainability-thumb2.jpg",
    },
  };

  const imageHoverStyle = {
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
    },
  };

  // Function to check if the screen width is for tablet or above
  const isTabletOrAbove = () => {
    return window.innerWidth > 768; // 768px is a common breakpoint for tablets
  };

  return (
    <>
      <SEO title={detailsService.title} />
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerTwo
          title={detailsService.title}
          paragraph={detailsService.description}
          styleClass=""
          mainThumb={detailsService.image}
          color="#01a951" // Pass the color prop here
          page="Sustainability"
        />

        <div
          className="section  spalsh-why-choose"
          id="splash-why-choose"
          style={{ padding: !isTabletOrAbove() ? "60px 0px 0px" : "110px 0px 0px" }}
        >
          <div className="container">
            <div className="row">
              {detailsService.process.steps.map((data) => (
                <div className="col-xl-4 col-lg-6" key={data.id}>
                  <div
                    className="why-buy-box"
                    style={isTabletOrAbove() ? { minHeight: "408px" } : { minHeight: "unset" }}
                  >
                    <div className="heading"  style={{ display: 'flex', alignItems: 'center', paddingBottom: !isTabletOrAbove() ? "10px" : "" }}>
                      <div className="icon">
                        <img
                          src={process.env.PUBLIC_URL + data.icon}
                          alt="Thumb"
                        />
                      </div>
                      <h5
                        className="title"
                        style={{ color: "#4ba65b", margin: 0 }}
                        dangerouslySetInnerHTML={{ __html: data.title }}
                      ></h5>
                    </div>
                    <p>{data.paragraph}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <CounterUpTwo />
        <AboutThree />
        <div className="container" style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Sustainability;
